const OFFLINE_DOWNLOAD_LOCK = "ebooks-reader-offline-pdf-download"

export async function withOfflineDownloadLock(work, { lockManager = globalThis.navigator?.locks } = {}) {
  if (!lockManager?.request) return false

  return lockManager.request(
    OFFLINE_DOWNLOAD_LOCK,
    { mode: "exclusive", ifAvailable: true },
    async (lock) => {
      if (!lock) return false

      await work()
      return true
    }
  )
}

export async function withOfflineCleanupLock(work, { lockManager = globalThis.navigator?.locks, ifAvailable = false } = {}) {
  if (!lockManager?.request) return false

  return lockManager.request(
    OFFLINE_DOWNLOAD_LOCK,
    { mode: "exclusive", ...(ifAvailable && { ifAvailable: true }) },
    async (lock) => {
      if (!lock) return false

      await work()
      return true
    }
  )
}
